<template>
    <div>
        <div class="fixed bg-gray-500 opacity-50 min-h-screen min-w-screen h-full w-full top-0 left-0 right-0 z-40"></div>
        <div class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-50">
            <div class="relative flex flex-col justify-between bg-white z-50 max-h-[95vh] w-[32rem] rounded-lg py-10 px-16 overflow-visible">
                <svg @click="closeLinkSelectedGoodToKassaWindow" class="w-8 h-8 absolute top-[10px] right-[12px] text-gray-500 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <div class="flex items-center mb-6">
                    <p v-if="mode == 'link'" class="text-xl">Прикрепить товары к кассе</p>
                    <p v-else class="text-xl">Открепить товары от кассы</p>
                </div>
                <div class="mb-6">
                    <KassaSelection v-model:kassaParam="kassa" labelContent="Выберите кассу" ref="kassaSelection"/>
                </div>
                <div v-if="mode == 'unlink'" class="mb-6">
                    <p class="text-gray-500 text-sm">Что вы хотите сделать с остатками товаров?</p>
                    <div class="flex flex-col items-start">
                        <RadioInput v-model:radioParam="command" name="command" value="move" labelContent="Переместить на главный склад" ref="commandSelection"/>
                        <RadioInput v-model:radioParam="command" name="command" value="delete" labelContent="Удалить"/>
                    </div>
                </div>
                <button @click.stop="linkUnlinkSelectedGoods" :disabled="buttonIsDisabled" type="button" class="mt-4 text-center bg-custom-blue hover:bg-custom-blue-hover flex items-center justify-center text-white font-medium rounded-lg text-sm px-5 py-2">Сохранить</button>
            </div>
        </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';

    import KassaSelection from '@/components/InputComponents/KassaSelection.vue';
    import RadioInput from '@/components/InputComponents/RadioInput.vue';

    export default {
        name: "UploadGoodsCSVModalWindowComponent",
        components: {
            KassaSelection,
            RadioInput,
        },
        props: {
            linkUnlinkSelecedGoodsToKassaWindowIsOpened: {
                type: Boolean,
                required: true,
            },
            selectedGoodIds: {
                type: Array,
                required: true,
            },
            mode: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                kassa: null,
                command: null,
                buttonIsDisabled: false,
            }
        },
        computed: {
            ...mapState(["kassas"]),
        },
        methods: {
            validateData() {
                if (!this.kassa) {
                    this.$refs.kassaSelection.$refs.kassaSelectionButton.click();
                    return false;
                }
                if (this.mode == "unlink" && !this.command) {
                    const commandSelection = this.$refs.commandSelection.$refs.radioInput;
                    commandSelection.setCustomValidity("Выберите действие");
                    commandSelection.reportValidity();
                    return false
                }
                return true;
            },
            closeLinkSelectedGoodToKassaWindow() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:linkUnlinkSelecedGoodsToKassaWindowIsOpened", false);
            },
            async linkUnlinkSelectedGoods() {
                this.buttonIsDisabled = true;

                if (!this.validateData()) {
                    this.buttonIsDisabled = false;
                    return;
                }

                if (this.mode == "link") {
                    const data = {
                        good_ids: this.selectedGoodIds,
                        shop_id: this.kassa,
                    }
                    const result = await this.$store.dispatch("linkGoodsToShop", data);
                    if (result.successfully) {
                        await this.$store.dispatch("fetchGoods");
                        this.$notify("Позиции каталога успешно прикреплены к кассе", "black");
                        this.closeLinkSelectedGoodToKassaWindow();
                        this.$emit("complete");
                    }
                } else {
                    const data = {
                        good_ids: this.selectedGoodIds,
                        shop_id: this.kassa,
                        mode: this.command,
                    }
                    const result = await this.$store.dispatch("unlinkGoodsToShop", data)
                    if (result.successfully) {
                        await this.$store.dispatch("fetchGoods");
                        this.$notify("Позиции каталога успешно откреплены от кассы", "black");
                        this.closeLinkSelectedGoodToKassaWindow();
                        this.$emit("complete");
                    }
                }

                this.buttonIsDisabled = false;
            },
        },
        mounted() {

        },
    }
</script>